export const countryCode = {
  FR: 'FR',
  GB: 'GB',
  ES: 'ES',
  DE: 'DE',
  IT: 'IT',
  NO: 'NO',
  SE: 'SE',
  FI: 'FI'
}

export const getDistanceFromCoordinates = (placeA, placeB, country) => {
  let distance = null
  switch (country) {
    case countryCode.FR:
    case countryCode.GB:
    case countryCode.DE:
    case countryCode.ES:
    case countryCode.IT:
    case countryCode.NO:
    case countryCode.SE:
    case countryCode.FI: {
      const a = 3.14 / 180

      const t =
        Math.sin(placeA.latitude * a) * Math.sin(placeB.latitude * a) +
        Math.cos(placeA.latitude * a) *
          Math.cos(placeB.latitude * a) *
          Math.cos(placeA.longitude * a - placeB.longitude * a)
      distance = Math.atan(-t / Math.sqrt(-t * t + 1)) + 2 * Math.atan(1)
      distance = distance * 3437.74677 * 1.1508 * 1.6093470878864446
      distance = Math.round(distance, 1)
      break
    }
    default:
      break
  }
  return distance
}
